export default "__VITE_ASSET__B5enU15N__"